module.exports = __webpack_public_path__ + "media/images/vantagens_desvantagens-a388a29d773c5ccfcda06c57ba509ea0.svg";